import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";

import useAlternateUrl from "hooks/useAlternateUrl";
import useCanonical from "hooks/useCanonical";
import useDomain from "hooks/useDomain";

type Props = {
  canonicalParams?: string[];
  description: string;
  image?: string;
  title: string;
  robots?: string;
  isStrainListPage?: boolean;
};

const MetaTags = ({
  canonicalParams,
  description,
  image = "https://public.leafly.com/web-home/logo-1200x630.png",
  robots,
  title,
  isStrainListPage,
}: Props): JSX.Element => {
  const canonicalUrl = useCanonical(canonicalParams);
  const { usUrl, caUrl } = useAlternateUrl();
  const router = useRouter();
  const {
    query: { page = 1 },
    asPath,
  } = router;
  const domain = useDomain();

  const getCanonicalUrl = (path: string, page: string | string[] | number) => {
    if (isStrainListPage) {
      let canonicalUrl = `${domain}${path.split("?")[0]}`;
      canonicalUrl += Number(page) > 1 ? `?page=${page}` : "";
      return canonicalUrl;
    }
    return canonicalUrl;
  };

  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {robots && <meta name="robots" content={robots} />}
      <title>{title}</title>
      <link rel="canonical" href={getCanonicalUrl(asPath, page)} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${domain}${asPath}`} />
      <meta property="fb:app_id" content="210495295724612" />
      <meta property="og:image" content={image} />
      <meta name="twitter:app:country" content="US" />
      <meta name="twitter:app:id:iphone" content="416456429" />
      <meta name="twitter:app:id:ipad" content="416456429" />
      <meta name="twitter:app:id:googleplay" content="leafly.android" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link href={`${usUrl}`} hrefLang="en-us" rel="alternate" />
      <link href={`${caUrl}`} hrefLang="en-CA" rel="alternate" />
    </Head>
  );
};

export default MetaTags;
